/**
 * Kind of the structure definition
 */
export enum StructureDefinitionKind {
  RESOURCE = 'Resource',
  VALUE = 'Value'
}
